import {
  ConfirmDocumentReceiptDeviceStrategy,
  ConfirmDocumentReceiptFileSystemStrategy,
  ConfirmDocumentReceiptDepositSignLoginPswStrategy,
  ConfirmDocumentReceiptDiiaStrategy,
  ConfirmDocumentReceiptCloudKeyFileSystemStrategy,
  ConfirmDocumentReceiptWithQrCloudProviderStrategy,
  ConfirmDocumentReceiptWithIdCloudProviderStrategy
} from '@/sign/strategies/confirm-document-receipt-private-key.strategy';
import { SignStrategyFactory } from './sign-strategy.factory';

export class ConfirmDocumentReceiptStrategyFactory extends SignStrategyFactory {
  constructor() {
    super(
      ConfirmDocumentReceiptFileSystemStrategy,
      ConfirmDocumentReceiptDeviceStrategy,
      ConfirmDocumentReceiptDepositSignLoginPswStrategy,
      ConfirmDocumentReceiptDiiaStrategy,
      ConfirmDocumentReceiptCloudKeyFileSystemStrategy,
      ConfirmDocumentReceiptWithQrCloudProviderStrategy,
      ConfirmDocumentReceiptWithIdCloudProviderStrategy);
  }
}
